/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Search from 'antd/lib/input/Search';
import { Table, Button, Pagination } from 'antd';
import instance from '../Communal/instance';
const { Column } = Table;
function CtfSubmit() {
    const [initData, setInitData] = useState(
        {
            data: [],
            allCount: []
        }
    );
    const [filter, setFilter] = useState(
        {
            page: 1,
            size: 6,
            search: "",
            classify: [],
            status: [],
            ordering: "",
            test_type: "",
            system: []
        }
    );
    const [sortedInfo, setSortedInfo] = useState({})
    const [filteredInfo, setFilteredInfo] = useState({
        classify: [],
        status: [],
        system: []
    })
    const [classify, setClassify] = useState([]);
    const [systemList, setSystemList] = useState([]);
    //获取工具列表
    useEffect(() => {
        getList();
    }, [filter]);
    useEffect(() => {
        instance.get("/tool/classify/").then(data => {
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    data[i].text = data[i].name;
                    data[i].value = data[i].id
                }
            }
            setClassify(data)
        })
        getSystem();
    }, [])
    const getSystem = () => {
        instance.get('/tool/system/').then(res => {
            if (res.length > 0) {
                for (var i = 0; i < res.length; i++) {
                    res[i].text = res[i].name;
                    res[i].value = res[i].id
                }
            }
            setSystemList(res)
        })
    }
    let getList = () => {
        instance.get("/users/sub/tool/", { params: filter }).then(data => {
            initData.data = data.results;
            initData.allCount = data.count;
            setInitData({ ...initData })
        })
    }
    let handleTableChange = (pagination, filters, sorter) => {
        if (filters.classify) {
            filter.classify = filters.classify;
            filteredInfo.classify = filters.classify
        } else {
            filter.classify = [];
            filteredInfo.classify = [];
        }
        if (filters.system_name) {
            filter.system = filters.system_name;
            filteredInfo.system = filters.system_name
        } else {
            filter.system = [];
            filteredInfo.system = [];
        }
        if (filters.test_type) {
            filter.test_type = filters.test_type[0];
            filteredInfo.test_type = filters.test_type
        } else {
            filter.test_type = "";
            filteredInfo.test_type = [];
        }

        if (filters.status) {
            filter.status = filters.status;
            filteredInfo.status = filters.status;
        } else {
            filter.status = [];
            filteredInfo.status = [];
        }
        if (sorter.order) {
            if (sorter.columnKey === "coin") {
                if (sorter.order === "ascend") {
                    filter.ordering = "coin"
                } else {
                    filter.ordering = "-coin"
                }
            }
        } else {
            filter.ordering = ""
        }
        filter.page = 1;
        setSortedInfo({ ...sorter })
        setFilter({ ...filter });
        setFilteredInfo({ ...filteredInfo })
    }
    return (
        <div className="resource-submit-list">
            <div className="title">提交工具</div>
            <div className="content">
                <div className="all-count">
                    总计：共<b>{initData.allCount}</b>个素材
                    <Search
                        value={filter.search}
                        placeholder="请输入关键字"
                        onChange={(e) => {
                            filter.page = 1;
                            filter.search = e.target.value;
                            setFilter({ ...filter })
                        }} />
                </div>
                <Table
                    dataSource={initData.data}
                    rowKey={record => record.id}
                    bordered
                    pagination={false}
                    onChange={handleTableChange}
                >
                    <Column
                        title="序号"
                        key="number"
                        align="center"
                        width="8%"
                        render={(text, record, index) => {
                            return filter.size * (filter.page - 1) + index + 1
                        }}
                    />
                    <Column
                        title="工具名称"
                        key="name"
                        align="center"
                        dataIndex="name"
                        width="19%"
                    />
                    <Column
                        title="工具体系"
                        key="system_name"
                        align="center"
                        dataIndex="system_name"
                        filters={systemList}
                        filteredValue={filteredInfo.system || null}
                        width="10%"
                        render={(text, record) => {
                            return <div>
                                {text ? text : '暂无体系'}
                            </div>
                        }}
                    />
                    <Column
                        title="工具类型"
                        key="classify"
                        align="center"
                        dataIndex="classify"
                        filters={classify}
                        filteredValue={filteredInfo.classify || null}
                        width="15%"
                        render={(text, record) => {
                            return <div>
                                {record.classify ? record.classify : <span>暂无一级分类</span>}&nbsp;/&nbsp;
                                {record.sec_classify ? record.sec_classify : <span>暂无二级分类</span>}
                            </div>
                        }}
                    />
                    <Column
                        title="审核状态"
                        key="status"
                        align="center"
                        dataIndex="status"
                        width="13%"
                        filters={
                            [
                                { text: "待审核", value: "0" },
                                { text: "通过", value: "1" },
                                { text: "待补充", value: "2" },
                                { text: "拒绝", value: "3" }
                            ]
                        }
                        filteredValue={filteredInfo.status || null}
                        render={(record) => {
                            return <span className="audit-status">
                                {
                                    record === 0 && "待审核"
                                }
                                {
                                    record === 1 && <span className="pass">通过</span>
                                }
                                {
                                    record === 2 && <span className="added">待补充</span>
                                }
                                {
                                    record === 3 && <span className="denied">拒绝</span>
                                }
                            </span>
                        }}
                    />
                    <Column
                        title="奖励"
                        key="coin"
                        align="center"
                        dataIndex="coin"
                        width="10%"
                        sorter="true"
                        sortOrder={sortedInfo.columnKey === 'coin' && sortedInfo.order}
                    />
                    <Column
                        title="提交时间"
                        key="sub_time"
                        align="center"
                        dataIndex="sub_time"
                        width="17%"
                    />
                    <Column
                        title="操作"
                        key="operate"
                        align="center"
                        width="15%"
                        render={(record) => {
                            return <span className="table-operation">
                                <Button type="link" onClick={() => window.location.href = "/#/activity/tooldetail/2/" + record.id}>详情</Button>
                                <b></b>
                                {
                                    record.status === 1 ?
                                        <Button type="link" disabled>编辑</Button>
                                        : <Button type="link" onClick={() => window.location.href = "/#/activity/submittool/-1/1/" + record.id}>编辑</Button>
                                }
                            </span>
                        }}
                    />
                </Table>
                <Pagination
                    showQuickJumper={true}
                    current={filter.page}
                    pageSize={filter.size}
                    total={initData.allCount}
                    hideOnSinglePage={true}
                    showSizeChanger={false}
                    className="flip-over"
                    style={{ margin: "30px 0" }}
                    onChange={
                        ((page) => {
                            let data = { ...filter }
                            data.page = page;
                            setFilter(data)
                        })
                    }
                />
            </div>
        </div>
    )
}
export default CtfSubmit;